// navigator.userAgentData.platform would be the modern replacement, but it's Chromium-only - it
// doesn't exist in Safari or Firefox. userAgent sniffing is deprecated but still the only check
// that works everywhere, so we use it here on purpose.
export function isMacPlatform(): boolean {
  return /Mac/.test(navigator.userAgent);
}
